import { Col, Collapse } from 'antd';

import LabelPrintingToolbarCardPanel from './CardPanel';
import LabelPrintingToolbarContentPanel from './ContentPanel';
import LabelPrintingToolbarLayoutPanel from './LayoutPanel';
import LabelPrintingToolbarPresetsPanel from './PresetsPanel';

export default function WrapperLabelPrintingPageToolbar() {
  return (
    <Col className="print-page-toolbar">
      <Collapse
        defaultActiveKey={['presets', 'layout', 'content', 'card']}
        className="print-page-toolbar-collapse"
      >
        <Collapse.Panel header="Padrões de impressão" key="presets">
          <LabelPrintingToolbarPresetsPanel />
        </Collapse.Panel>

        <Collapse.Panel header="Layout da página" key="layout">
          <LabelPrintingToolbarLayoutPanel />
        </Collapse.Panel>

        <Collapse.Panel header="Etiqueta (card)" key="card">
          <LabelPrintingToolbarContentPanel />
          <LabelPrintingToolbarCardPanel />
        </Collapse.Panel>
      </Collapse>
    </Col>
  );
}
